import { render, staticRenderFns } from "./applyForm.vue?vue&type=template&id=550ed16d&scoped=true"
import script from "./applyForm.vue?vue&type=script&lang=js"
export * from "./applyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550ed16d",
  null
  
)

export default component.exports